"use client";

import { useI18n } from "@llmgateway/i18n/react";

import type { TranslationValues } from "@llmgateway/i18n";

interface I18nTextProps {
	translationKey: string;
	values?: TranslationValues;
}

export function I18nText({ translationKey, values }: I18nTextProps) {
	const { t } = useI18n();

	return <>{t(translationKey, values)}</>;
}
